export const genders = [
    {
      value : "NAM",
      label : "Nam"
    },
    {
      value : "NU",
      label : "Nữ"
    }
]